import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Notar la condición",
    opening: localizedGenderNode(
      [
      "Hoy no intento cambiarlo.",
      "Solo noto la condición con la que vivo.",
      "Eso es suficiente por ahora."
    ],
      [
      "Hoy no intento cambiarlo.",
      "Solo noto la condición con la que vivo.",
      "Eso es suficiente por ahora."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo siento que solo soy bueno/a si tengo éxito?",
      "¿Qué está pasando a mi alrededor entonces?",
      "¿Cómo se siente en mi cuerpo?"
    ],
      [
      "¿Cuándo siento que solo soy bueno/a si tengo éxito?",
      "¿Qué está pasando a mi alrededor entonces?",
      "¿Cómo se siente en mi cuerpo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Notar la condición ya es un comienzo."
    ],
      [
      "Notar la condición ya es un comienzo."
    ]
    ),
    action: localizedGenderNode(
      "una respiración con las palabras \"Estoy aquí\".",
      "una respiración con las palabras \"Estoy aquí\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "De dónde viene",
    opening: localizedGenderNode(
      [
      "Hoy noto de dónde vino la condición.",
      "Sin culpa.",
      "Solo ver."
    ],
      [
      "Hoy noto de dónde vino la condición.",
      "Sin culpa.",
      "Solo ver."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento el pecho."
    ],
      [
      "Respiro despacio.",
      "Siento el pecho."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo escuché ese mensaje por primera vez?",
      "¿Quién o qué lo reforzó?",
      "¿Qué me hizo entonces?"
    ],
      [
      "¿Cuándo escuché ese mensaje por primera vez?",
      "¿Quién o qué lo reforzó?",
      "¿Qué me hizo entonces?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Ver el origen suaviza el presente."
    ],
      [
      "Ver el origen suaviza el presente."
    ]
    ),
    action: localizedGenderNode(
      "escribir una palabra sobre el origen.",
      "escribir una palabra sobre el origen."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Qué intento demostrar",
    opening: localizedGenderNode(
      [
      "Hoy pregunto qué intento demostrar.",
      "No crítica.",
      "Curiosidad."
    ],
      [
      "Hoy pregunto qué intento demostrar.",
      "No crítica.",
      "Curiosidad."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué intento demostrar cuando tengo éxito?",
      "¿A quién intento mostrar?",
      "¿Qué quisiera que vieran en mí sin logros?"
    ],
      [
      "¿Qué intento demostrar cuando tengo éxito?",
      "¿A quién intento mostrar?",
      "¿Qué quisiera que vieran en mí sin logros?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Demostrar a veces es un intento de recibir amor."
    ],
      [
      "Demostrar a veces es un intento de recibir amor."
    ]
    ),
    action: localizedGenderNode(
      "escribir una verdad sobre mí sin un logro.",
      "escribir una verdad sobre mí sin un logro."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "La parte que teme equivocarse",
    opening: localizedGenderNode(
      [
      "Hoy noto la parte que teme equivocarse.",
      "No para pelear.",
      "Solo estar con ella."
    ],
      [
      "Hoy noto la parte que teme equivocarse.",
      "No para pelear.",
      "Solo estar con ella."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento el corazón."
    ],
      [
      "Respiro despacio.",
      "Siento el corazón."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Dónde siento este miedo en mi cuerpo?",
      "¿Qué necesita de mí ahora?",
      "¿Cómo se siente estar con él un momento?"
    ],
      [
      "¿Dónde siento este miedo en mi cuerpo?",
      "¿Qué necesita de mí ahora?",
      "¿Cómo se siente estar con él un momento?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Estar con él un momento ya es un cambio pequeño."
    ],
      [
      "Estar con él un momento ya es un cambio pequeño."
    ]
    ),
    action: localizedGenderNode(
      "poner una mano en el corazón y respirar.",
      "poner una mano en el corazón y respirar."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "El costo de la condición",
    opening: localizedGenderNode(
      [
      "Hoy veo el costo de la condición.",
      "No para culpar.",
      "Solo ver."
    ],
      [
      "Hoy veo el costo de la condición.",
      "No para culpar.",
      "Solo ver."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuál es el precio que pago por esta condición?",
      "¿Qué pierdo en el camino?",
      "¿Qué me gustaría que fuera diferente?"
    ],
      [
      "¿Cuál es el precio que pago por esta condición?",
      "¿Qué pierdo en el camino?",
      "¿Qué me gustaría que fuera diferente?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Ver el costo abre espacio para un pequeño cambio."
    ],
      [
      "Ver el costo abre espacio para un pequeño cambio."
    ]
    ),
    action: localizedGenderNode(
      "escribir una palabra sobre el costo.",
      "escribir una palabra sobre el costo."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Pedir suavidad",
    opening: localizedGenderNode(
      [
      "Hoy formulo una petición pequeña de suavidad.",
      "No grande.",
      "Solo pequeña."
    ],
      [
      "Hoy formulo una petición pequeña de suavidad.",
      "No grande.",
      "Solo pequeña."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro.",
      "Estoy aquí."
    ],
      [
      "Respiro.",
      "Estoy aquí."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cómo me gustaría que me hablaran cuando me equivoco?",
      "¿Cómo puedo hablarme así?",
      "¿Cuál es un paso pequeño hacia eso?"
    ],
      [
      "¿Cómo me gustaría que me hablaran cuando me equivoco?",
      "¿Cómo puedo hablarme así?",
      "¿Cuál es un paso pequeño hacia eso?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una pequeña suavidad puede abrir la respiración."
    ],
      [
      "Una pequeña suavidad puede abrir la respiración."
    ]
    ),
    action: localizedGenderNode(
      "una frase suave para mí.",
      "una frase suave para mí."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Ser valioso/a incluso sin",
    opening: localizedGenderNode(
      [
      "Hoy observo cómo es ser valioso/a incluso sin logro.",
      "Solo un momento.",
      "No más."
    ],
      [
      "Hoy observo cómo es ser valioso/a incluso sin logro.",
      "Solo un momento.",
      "No más."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué es bueno en mí incluso sin logros?",
      "¿Cómo se siente decirlo?",
      "¿Qué temo que pase si lo creo?"
    ],
      [
      "¿Qué es bueno en mí incluso sin logros?",
      "¿Cómo se siente decirlo?",
      "¿Qué temo que pase si lo creo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una palabra buena puede ser un ancla."
    ],
      [
      "Una palabra buena puede ser un ancla."
    ]
    ),
    action: localizedGenderNode(
      "decir una palabra buena sobre mí.",
      "decir una palabra buena sobre mí."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Un límite frente a exigencias",
    opening: localizedGenderNode(
      [
      "Hoy observo un límite pequeño frente a exigencias.",
      "No para alejarme.",
      "Solo proteger."
    ],
      [
      "Hoy observo un límite pequeño frente a exigencias.",
      "No para alejarme.",
      "Solo proteger."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento los hombros."
    ],
      [
      "Respiro despacio.",
      "Siento los hombros."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Dónde es más fuerte la exigencia sobre mí?",
      "¿Qué límite pequeño me aliviaría?",
      "¿Cómo puedo decírmelo a mí?"
    ],
      [
      "¿Dónde es más fuerte la exigencia sobre mí?",
      "¿Qué límite pequeño me aliviaría?",
      "¿Cómo puedo decírmelo a mí?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un límite pequeño protege el corazón."
    ],
      [
      "Un límite pequeño protege el corazón."
    ]
    ),
    action: localizedGenderNode(
      "una frase de límite para mí.",
      "una frase de límite para mí."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Pedir calidez",
    opening: localizedGenderNode(
      [
      "Hoy observo cómo pedir calidez.",
      "Sin drama.",
      "Una petición pequeña."
    ],
      [
      "Hoy observo cómo pedir calidez.",
      "Sin drama.",
      "Una petición pequeña."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué calidez me falta?",
      "¿Cómo puedo pedirla con suavidad?",
      "¿Cuál es un paso pequeño hacia eso?"
    ],
      [
      "¿Qué calidez me falta?",
      "¿Cómo puedo pedirla con suavidad?",
      "¿Cuál es un paso pequeño hacia eso?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una petición puede suavizar."
    ],
      [
      "Una petición puede suavizar."
    ]
    ),
    action: localizedGenderNode(
      "escribir la petición en una frase.",
      "escribir la petición en una frase."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Quedarme conmigo",
    opening: localizedGenderNode(
      [
      "Hoy practico quedarme conmigo cuando no tengo éxito.",
      "No huir.",
      "Solo estar."
    ],
      [
      "Hoy practico quedarme conmigo cuando no tengo éxito.",
      "No huir.",
      "Solo estar."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué me ayuda a quedarme conmigo?",
      "¿Qué me saca de mí?",
      "¿Qué podría ayudarme a volver?"
    ],
      [
      "¿Qué me ayuda a quedarme conmigo?",
      "¿Qué me saca de mí?",
      "¿Qué podría ayudarme a volver?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Quedarme conmigo es una pequeña reparación."
    ],
      [
      "Quedarme conmigo es una pequeña reparación."
    ]
    ),
    action: localizedGenderNode(
      "una respiración después de un error pequeño.",
      "una respiración después de un error pequeño."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Un valor más allá del logro",
    opening: localizedGenderNode(
      [
      "Hoy busco un valor más allá del logro.",
      "Pequeño.",
      "Pero verdadero."
    ],
      [
      "Hoy busco un valor más allá del logro.",
      "Pequeño.",
      "Pero verdadero."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué valor permanece incluso sin logros?",
      "¿Cómo se ve ese valor en un día normal?",
      "¿Qué paso pequeño podría honrarlo?"
    ],
      [
      "¿Qué valor permanece incluso sin logros?",
      "¿Cómo se ve ese valor en un día normal?",
      "¿Qué paso pequeño podría honrarlo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un valor es un ancla."
    ],
      [
      "Un valor es un ancla."
    ]
    ),
    action: localizedGenderNode(
      "una palabra que exprese ese valor.",
      "una palabra que exprese ese valor."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Escucharme",
    opening: localizedGenderNode(
      [
      "Hoy practico escucharme.",
      "Incluso cuando no hay éxito.",
      "También entonces."
    ],
      [
      "Hoy practico escucharme.",
      "Incluso cuando no hay éxito.",
      "También entonces."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro despacio.",
      "Siento el corazón."
    ],
      [
      "Respiro despacio.",
      "Siento el corazón."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué necesito escuchar de mí hoy?",
      "¿Qué doy a otros que no me doy a mí?",
      "¿Cómo puedo darme eso a mí?"
    ],
      [
      "¿Qué necesito escuchar de mí hoy?",
      "¿Qué doy a otros que no me doy a mí?",
      "¿Cómo puedo darme eso a mí?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Escucharme es una pequeña reparación."
    ],
      [
      "Escucharme es una pequeña reparación."
    ]
    ),
    action: localizedGenderNode(
      "una frase suave para mí.",
      "una frase suave para mí."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Un paso pequeño de aceptación",
    opening: localizedGenderNode(
      [
      "Hoy elijo un paso pequeño de aceptación.",
      "Sin drama.",
      "Un paso pequeño."
    ],
      [
      "Hoy elijo un paso pequeño de aceptación.",
      "Sin drama.",
      "Un paso pequeño."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo un momento.",
      "Una respiración."
    ],
      [
      "Me detengo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué paso pequeño estoy dispuesto/a a intentar?",
      "¿Qué se sentirá lo suficientemente seguro?",
      "¿Cómo me va a proteger?"
    ],
      [
      "¿Qué paso pequeño estoy dispuesto/a a intentar?",
      "¿Qué se sentirá lo suficientemente seguro?",
      "¿Cómo me va a proteger?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un paso pequeño es suficiente para moverme."
    ],
      [
      "Un paso pequeño es suficiente para moverme."
    ]
    ),
    action: localizedGenderNode(
      "elegir un paso pequeño y recordarlo.",
      "elegir un paso pequeño y recordarlo."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Frase de regreso",
    opening: localizedGenderNode(
      [
      "Hoy elijo una frase que me devuelve al amor que no depende de mi éxito.",
      "Cuando caigo.",
      "Una frase pequeña."
    ],
      [
      "Hoy elijo una frase que me devuelve al amor que no depende de mi éxito.",
      "Cuando caigo.",
      "Una frase pequeña."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro.",
      "Estoy aquí."
    ],
      [
      "Respiro.",
      "Estoy aquí."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué aprendí sobre esta condición?",
      "¿Cuál es la primera señal de que vuelve?",
      "¿Qué frase me devuelve un momento antes?"
    ],
      [
      "¿Qué aprendí sobre esta condición?",
      "¿Cuál es la primera señal de que vuelve?",
      "¿Qué frase me devuelve un momento antes?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Puedo equivocarme y aun así quedarme conmigo."
    ],
      [
      "Puedo equivocarme y aun así quedarme conmigo."
    ]
    ),
    action: localizedGenderNode(
      "decir la nueva frase una vez.",
      "decir la nueva frase una vez."
    ),
  },
].map(buildNormalizedDay);

export const conditionalLoveGoodOnlyIfISucceedBlueprintEs = buildNormalizedPilotBlueprint({
  id: "conditional_love_good_only_if_i_succeed_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "conditional_love_good_only_if_i_succeed",
  category: "childhood_parents_past_wounds",
  journeyName: {
    he: "אהבה על תנאי (טוב רק אם אני מצליח/ה)",
    en: "Conditional love (good only if I succeed)",
    es: "Amor condicional (solo soy bueno/a si tengo éxito)",
  },
  days,
});

export default conditionalLoveGoodOnlyIfISucceedBlueprintEs;
